import useAuth from '../Hooks/auth/useAuth';
import axios from 'axios';

export const DOTNET_URL = 'https://aetherforgedotnetserver.onrender.com/'; //'http://localhost:5050';

const axiosDotnet = axios.create({
  baseURL: DOTNET_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});

// Request Interceptor - Attach JWT Token
// axiosDotnet.interceptors.request.use(
//   (config) => {
//       const { auth } = useAuth();          
//       const token = auth?.accessToken;

//       if (token) {
//           config.headers.Authorization = `Bearer ${token}`;
//       }

//       return config;
//   },
//   (error) => {
//       console.log(err);
//       return Promise.reject(error);
//   }
// );

// Optional: global response error handling
axiosDotnet.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Dispatch a custom event that your auth provider can listen to
      window.dispatchEvent(new CustomEvent('auth:unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default axiosDotnet;